module.exports = __webpack_public_path__ + "img/syukyaku-dtp-001sp.ff8522df.jpg";